/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Rehman Ali",
  title: "Hi all, I'm Rehman 👋",
  subTitle: emoji(
    "A passionate Backend Developer 🚀 with 4+ years of real-world experience across 5 companies and multiple freelance engagements. Currently pursuing MS in Computer Science at FAST-NUCES. Specializes in RESTful API design, JWT-secured authentication, real-time communication via Socket.io, and AI integration. Proven track record of delivering clean, documented, production-grade backend systems for international clients, on time, every time."
  ),
  resumeLink: "/Rehman_Ali_Resume_dev.pdf",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/rehmanjatoirj",
  linkedin: "https://linkedin.com/in/rehman-ali-bd",
  gmail: "jatoirehman36@gmail.com",
  gitlab: "",
  facebook: "",
  medium: "",
  stackoverflow: "",
  display: true // Set true to display this section, defaults to false
};

const navBar = [
  {name: "Skills", link: "#skills"},
  {name: "Work Experiences", link: "#experience"},
  {name: "Education", link: "#education"},
  {name: "Contact Me", link: "#contact"}
];

// Skills Section

const skillsSection = {
  title: "What I Do ⚡",
  subTitle: "BACKEND DEVELOPER WHO BUILDS SECURE, SCALABLE, REAL-TIME SYSTEMS",
  skills: [
    emoji("Building backend systems ⚡ with Node.js and Express for secure, scalable applications"),
    emoji("Crafting documented REST APIs 🔐 with JWT authentication and role-based access"),
    emoji("Designing database solutions 🗄️ using MongoDB, MySQL, PostgreSQL, and Mongoose"),
    emoji("Creating real-time systems 📡 with Socket.io and Dockerized deployments"),
    emoji("Working efficiently 🛠️ with Git, npm, JavaScript, Postman, and backend-first system design")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {skillName: "nodejs", fontAwesomeClassname: "fab fa-node"},
    {skillName: "Express", fontAwesomeClassname: "simple-icons:express"},
    {skillName: "MongoDB", fontAwesomeClassname: "simple-icons:mongodb"},
    {skillName: "MySQL", fontAwesomeClassname: "simple-icons:mysql"},
    {skillName: "PostgreSQL", fontAwesomeClassname: "simple-icons:postgresql"},
    {skillName: "Docker", fontAwesomeClassname: "fab fa-docker"},
    {skillName: "git", fontAwesomeClassname: "fab fa-git-alt"},
    {skillName: "JavaScript", fontAwesomeClassname: "fab fa-js"},
    {skillName: "npm", fontAwesomeClassname: "fab fa-npm"},
    {skillName: "Socket.io", fontAwesomeClassname: "simple-icons:socketdotio"},
    {skillName: "Postman", fontAwesomeClassname: "simple-icons:postman"},
    {skillName: "JWT", fontAwesomeClassname: "simple-icons:jsonwebtokens"}
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName:
        "FAST-NUCES (National University of Computer & Emerging Sciences)",
      logo:
        "https://upload.wikimedia.org/wikipedia/en/f/f6/FAST_National_University_Logo.png",
      subHeader: "Master of Science - Computer Science",
      duration: "Feb 2024 - Jan 2026",
      desc: "Currently pursuing an MS in Computer Science with a focus on backend systems, architecture, and modern application development.",
      descBullets: [
        "Advanced study aligned with backend engineering and system design",
        "Balancing graduate studies with ongoing delivery of production-ready backend projects"
      ]
    },
    {
      schoolName:
        "Quaid-e-Awam University of Engineering, Sciences & Technology, Nawabshah",
      logo: "https://upload.wikimedia.org/wikipedia/en/0/0c/QUEST_logo.jpg",
      subHeader: "Bachelor of Engineering - Electronics Engineering",
      duration: "Apr 2017 - May 2021",
      desc: "Built a strong analytical and engineering foundation that now supports robust backend problem solving and systems thinking.",
      descBullets: [
        "Developed strong technical foundations in engineering, structure, and analytical reasoning"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Backend Development",
      progressPercentage: "95%"
    },
    {
      Stack: "REST API Design",
      progressPercentage: "95%"
    },
    {
      Stack: "Databases",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Back End Developer",
      company: "CodeChine",
      companylogo: "",
      date: "Mar 2026 - Present",
      desc: "Delivered production-ready backend systems for international clients with a focus on scalability, security, and clean engineering practices.",
      descBullets: [
        "Delivered 10+ production-ready backend projects for international clients via Upwork",
        "Built scalable REST APIs using Node.js and Express",
        "Implemented JWT authentication, role-based access control, and bcrypt password hashing",
        "Designed and managed MongoDB, MySQL, and PostgreSQL databases",
        "Integrated real-time features with Socket.io",
        "Embedded AI tools and automation workflows into client backend systems"
      ]
    },
    {
      role: "Back End Developer",
      company: "HexSoftwares",
      companylogo: "",
      date: "Mar 2026 - Present",
      desc: "Contributed to SaaS backend architecture and production REST API development.",
      descBullets: [
        "Built real-time notification and live tracking systems using Socket.io",
        "Maintained clean code standards with thorough API documentation"
      ]
    },
    {
      role: "Back End Developer",
      company: "Mehran IT Consultancy",
      companylogo: "",
      date: "Mar 2024 - Present",
      desc: "Developed backend APIs and database solutions for consultancy projects.",
      descBullets: [
        "Worked on secure user management systems and scalable data architectures",
        "Collaborated with cross-functional teams on end-to-end system delivery"
      ]
    },
    {
      role: "Back End Developer",
      company: "Tooliso",
      companylogo: "",
      date: "Feb 2022 - Present",
      desc: "Architected and maintained backend infrastructure for product growth and performance optimization.",
      descBullets: [
        "Built and scaled API systems supporting a growing user base",
        "Implemented performance optimization and system design best practices"
      ]
    },
    {
      role: "Freelance Back End Developer",
      company: "Upwork",
      companylogo: "",
      date: "Jan 2022 - Present",
      desc: "Built secure, scalable, real-time backend systems for international clients across multiple industries.",
      descBullets: [
        "Built a full real-time restaurant ordering system with live rider tracking, 15+ REST APIs, and JWT auth",
        "Developed secure user management ecosystems",
        "Served clients across e-commerce, logistics, healthcare, and food-tech industries"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  githubUserName: "rehmanjatoirj",
  showGithubProfile: "true",
  display: true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects 💻",
  subtitle: "BACKEND SYSTEMS I HAVE BUILT FOR REAL-WORLD CLIENTS",
  projects: [
    {
      projectName: "Food Delivery Platform",
      projectDesc:
        "Real-time food delivery backend with live rider tracking, 20+ REST APIs, Socket.io, JWT auth for customers, riders & restaurants.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "E-Commerce Backend System",
      projectDesc:
        "Full e-commerce REST API with 15+ endpoints, role-based access control, Stripe payment integration & inventory management.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Healthcare Appointment API",
      projectDesc:
        "Doctor-patient appointment system with real-time chat via Socket.io, secure medical records & email notifications.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Logistics & Shipment Tracking",
      projectDesc:
        "End-to-end shipment tracking platform with live Socket.io dashboard, Docker deployment & courier webhook integration.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Multi-Tenant SaaS Auth System",
      projectDesc:
        "Enterprise-grade multi-tenant authentication with JWT refresh rotation, Redis session management & per-tenant permissions.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "AI-Powered Content Backend",
      projectDesc:
        "OpenAI GPT integrated backend with prompt management, response caching, subscription tiers & async job processing.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Real-time Chat Application",
      projectDesc:
        "Full-featured chat backend with Socket.io rooms, private messaging, online presence tracking, message history with MongoDB, and JWT-secured WebSocket connections.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Blog & CMS Backend API",
      projectDesc:
        "Headless CMS REST API with role-based content management, rich text support, media uploads via Multer, SEO metadata handling, and category/tag filtering system.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Ride Booking System",
      projectDesc:
        "Uber-style ride booking backend with real-time driver tracking via Socket.io, fare calculation, trip lifecycle management, and live location broadcasting with JWT auth.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Hotel Booking & Management API",
      projectDesc:
        "Complete hotel reservation system with room availability engine, booking conflict prevention, guest management, payment integration, and admin dashboard REST APIs.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Job Portal Backend",
      projectDesc:
        "Full job board REST API with employer/candidate roles, job posting & application management, resume upload support, search & filter system, and email notification workflows.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    },
    {
      projectName: "Social Media REST API",
      projectDesc:
        "Scalable social platform backend with posts, comments, likes, follow/unfollow system, real-time notifications via Socket.io, media handling, and JWT-secured user profiles.",
      footerLink: [
        {name: "View on GitHub", url: "https://github.com/rehmanjatoirj"}
      ]
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆"),
  subtitle: "Achievements, certifications, and notable milestones.",
  achievementsCards: [],
  display: false
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle: "Technical writing and knowledge sharing.",
  displayMediumBlogs: "false",
  blogs: [],
  display: false
};

// Talks Sections

const talkSection = {
  title: "Talks",
  subtitle: emoji("Knowledge sharing and speaking engagements."),
  talks: [],
  display: false
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast"),
  subtitle: "Podcast appearances and conversations.",
  podcast: [],
  display: false
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: false
};

const contactInfo = {
  title: emoji("Contact Me 📬"),
  subtitle:
    "Discuss a project or just want to say hi? My inbox is open for all.",
  number: "",
  email_address: "jatoirehman36@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "",
  display: false
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  navBar,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
